import {match} from 'ts-pattern';

import {always} from 'ramda';

import {Nullish} from 'shared/web';

import {ChoiceBooleanValue} from '../constants/DEFAULT_VALUE_OPTIONS';

export const transformToString = (value: boolean | Nullish) =>
  match<boolean | Nullish, ChoiceBooleanValue>(value)
    .with(true, always('true'))
    .with(false, always('false'))
    .with(null, always('null'))
    .otherwise(always('null'));
